import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

interface CRDTNavigationProps {
  className?: string
}

const CRDTNavigation: React.FC<CRDTNavigationProps> = ({ className = '' }) => {
  const navigate = useNavigate()
  const location = useLocation()

  // 检查当前是否在CRDT模式下
  const isCRDTMode = location.pathname.includes('/crdt/')

  // 切换到CRDT模式
  const switchToCRDTMode = () => {
    if (location.pathname.includes('/notes/')) {
      const noteId = location.pathname.split('/notes/')[1]
      navigate(`/crdt/notes/${noteId}`)
    } else if (location.pathname.includes('/suji/')) {
      const noteId = location.pathname.split('/suji/')[1]
      navigate(`/crdt/suji/${noteId}`)
    }
  }

  // 切换到标准模式
  const switchToStandardMode = () => {
    if (location.pathname.includes('/crdt/notes/')) {
      const noteId = location.pathname.split('/crdt/notes/')[1]
      navigate(`/notes/${noteId}`)
    } else if (location.pathname.includes('/crdt/suji/')) {
      const noteId = location.pathname.split('/crdt/suji/')[1]
      navigate(`/suji/${noteId}`)
    }
  }

  // 只有在笔记编辑页面才显示切换按钮
  if (!location.pathname.includes('/notes/') && 
      !location.pathname.includes('/suji/') && 
      !location.pathname.includes('/crdt/')) {
    return null
  }

  return (
    <div className={`flex items-center space-x-2 text-xs ${className}`}>
      <span className="text-gray-500 dark:text-gray-400 hidden">
        同步模式:
      </span>
      
      {isCRDTMode ? (
        <>
          <span className="px-2 py-1 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded hidden">
            CRDT实时协作
          </span>
          <button
            onClick={switchToStandardMode}
            className="px-2 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors hidden"
            title="切换到标准模式"
          >
            标准模式
          </button>
        </>
      ) : (
        <>
          <span className="px-2 py-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded hidden">
            标准模式
          </span>
          <button
            onClick={switchToCRDTMode}
            className="px-2 py-1 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors hidden"
            title="切换到CRDT实时协作模式"
          >
            CRDT模式
          </button>
        </>
      )}
    </div>
  )
}

export default CRDTNavigation